import React from 'react'
import {
  AppButton,
  AppDialog,
  AppDialogBody,
  AppDialogContent,
  AppDialogDescription,
  AppDialogFooter,
  AppDialogHeader,
  AppDialogTitle,
} from '@easyllama/ui-components'

const KioskConfirmDialog = ({ open, learnerName, submitting, onOpenChange, onConfirm }) => (
  <AppDialog open={open} onOpenChange={onOpenChange}>
    <AppDialogContent size='sm'>
      <AppDialogHeader>
        <AppDialogTitle>Please confirm</AppDialogTitle>
        <AppDialogDescription className='sr-only'>Confirm your identity</AppDialogDescription>
      </AppDialogHeader>
      <AppDialogBody>
        <p className='text-center'>
          By clicking on &quot;Continue&quot; below, I certify that my name is{' '}
          <b>{learnerName}</b> and that I am the individual taking this course.
        </p>
      </AppDialogBody>
      <AppDialogFooter>
        {/* Keep the button focusable while submitting so closing the dialog can restore
            focus to Continue on the parent form (CAT-1493). Double-submit is guarded in
            PublicKioskContent via submittingRef. */}
        <AppButton size='lg' aria-busy={submitting || undefined} onClick={onConfirm} className='w-full'>
          {submitting ? 'Please wait…' : 'Continue'}
        </AppButton>
      </AppDialogFooter>
    </AppDialogContent>
  </AppDialog>
)

export default KioskConfirmDialog
